// extracted by mini-css-extract-plugin
export default {"button":"WebSearch__button--111S4","buttonGear":"WebSearch__buttonGear--2nUeE","menuButtonWrapper":"WebSearch__menuButtonWrapper--2tk5v"};